
import BaseButton from 'JS/components/BaseButton.vue';
import BCheckbox from 'JS/components/blain-form/BCheckbox.vue';
import Icon from 'JS/components/Icon.vue';
import OrderSummaryLine from 'JS/components/order/OrderSummaryLine.vue';
import { computed, defineComponent, PropType } from 'vue';
import { IAutomotiveWorkOrderLineItem } from 'JS/types/automotive/WorkOrderQuote';

export default defineComponent({
	components: {
		BCheckbox,
		OrderSummaryLine,
		BaseButton,
		Icon,
	},
	props: {
		item: {
			type: Object as PropType<IAutomotiveWorkOrderLineItem>,
			required: true,
		},
		selected: Boolean,
		price: {
			type: String,
			required: true,
		},
		accessibilityPrice: {
			type: String,
			required: true,
		}
	},
	emits: ['update:selected', 'more-info'],
	setup (props, { emit }) {
		const itemIsSelected = computed({
			get: () => props.selected,
			set: value => emit('update:selected', value),
		});

		return {
			itemIsSelected,
		};
	}
});
